import { render, staticRenderFns } from "./FormSceneWay.vue?vue&type=template&id=135ed530&scoped=true&"
import script from "./FormSceneWay.vue?vue&type=script&lang=js&"
export * from "./FormSceneWay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ed530",
  null
  
)

export default component.exports